/*
 * RESADE rs-bildvergleich.js (Runde 5, E-156, 27.09.2026)
 * Schieberegler zwischen zwei Fotos (sections/rs-bildvergleich.liquid). Das input type=range liegt unsichtbar über dem
 * Bild und trägt Tastatur (Pfeile 5 %, Bild auf und ab 10 %, Pos1, Ende) und Screenreader (aria-valuetext). Maus und
 * Touch setzen die Position über Pointer-Ereignisse; Touch folgt erst bei waagrechtem Ziehen, senkrecht scrollt die
 * Seite (touch-action: pan-y). Ein kurzer Tipp setzt die Linie an die Stelle. Die Marken bleiben stehen (seit E-159,
 * Denny: wie live). Keine Bewegung von selbst. Mehrfach ladbar, auch im Theme-Editor.
 */
(function () {
  'use strict';
  if (window.rsBildvergleichGeladen) return;
  window.rsBildvergleichGeladen = true;

  function einrichten(fig) {
    if (fig.rsBv) return;
    var buehne = fig.querySelector('.rs-bv__buehne');
    var regler = fig.querySelector('[data-rs-bv-regler]');
    if (!buehne || !regler) return;
    fig.rsBv = true;
    var namen = (regler.getAttribute('data-namen') || 'links|rechts').split('|');

    // Hauptthread 18.10.2026: Die Breite kommt vom ResizeObserver (nach dem Layout, nichts erzwungen), nicht aus
    // getBoundingClientRect beim Start. Vorher erzwang setzen(50) beim DOMContentLoaded Stil und Layout der Seite
    // (gemessen 7 ms, bei CPU 4x 35 ms). Ohne ResizeObserver misst setzen wie bisher.
    var breite = 0;
    var beobachtet = typeof window.ResizeObserver === 'function';
    function setzen(wert) {
      var v = Math.max(0, Math.min(100, Math.round(wert)));
      regler.value = String(v);
      buehne.style.setProperty('--rs-bv-pos', v + '%');
      // Der Kreis (48 px) bleibt am Rand ganz in der Bühne, die Linie läuft bis an den Rand (E-159)
      var bw = beobachtet ? breite : buehne.getBoundingClientRect().width;
      var x = (bw * v) / 100;
      var dx = bw ? Math.max(0, 26 - x) - Math.max(0, x - (bw - 26)) : 0;
      buehne.style.setProperty('--rs-bv-griff-dx', Math.round(dx) + 'px');
      regler.setAttribute('aria-valuetext', v + ' % ' + namen[0] + ', ' + (100 - v) + ' % ' + namen[1]);
    }

    function ausX(x) {
      var r = buehne.getBoundingClientRect();
      if (r.width) breite = r.width;
      if (r.width) setzen(((x - r.left) / r.width) * 100);
    }

    var ziehen = false;
    var start = null;
    buehne.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') {
        if (e.button !== 0) return;
        ziehen = true;
        ausX(e.clientX);
        try { buehne.setPointerCapture(e.pointerId); } catch (f) {}
        regler.focus({ preventScroll: true });
        e.preventDefault();
      } else {
        start = { x: e.clientX, y: e.clientY, id: e.pointerId, entschieden: false };
      }
    });
    buehne.addEventListener('pointermove', function (e) {
      if (ziehen) { ausX(e.clientX); return; }
      if (!start || start.entschieden || e.pointerId !== start.id) return;
      var dx = Math.abs(e.clientX - start.x);
      var dy = Math.abs(e.clientY - start.y);
      if (dx > 6 && dx > dy) {
        start.entschieden = true;
        ziehen = true;
        try { buehne.setPointerCapture(e.pointerId); } catch (f) {}
        ausX(e.clientX);
      } else if (dy > 6) {
        start.entschieden = true;
      }
    });
    function ende(e) {
      if (start && !start.entschieden && e && e.type === 'pointerup') ausX(e.clientX);
      ziehen = false;
      start = null;
    }
    buehne.addEventListener('pointerup', ende);
    buehne.addEventListener('pointercancel', ende);

    regler.addEventListener('input', function () { setzen(Number(regler.value)); });
    if (beobachtet) {
      new window.ResizeObserver(function (eintraege) {
        var e = eintraege[eintraege.length - 1];
        var w = e.borderBoxSize && e.borderBoxSize[0] ? e.borderBoxSize[0].inlineSize : e.contentRect.width;
        if (!w || Math.abs(w - breite) < 0.5) return;
        breite = w;
        setzen(Number(regler.value));
      }).observe(buehne);
    } else {
      window.addEventListener('resize', function () { setzen(Number(regler.value)); });
    }
    regler.addEventListener('keydown', function (e) {
      var v = Number(regler.value);
      var n = null;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') n = v - 5;
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') n = v + 5;
      else if (e.key === 'PageDown') n = v - 10;
      else if (e.key === 'PageUp') n = v + 10;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = 100;
      if (n !== null) { e.preventDefault(); setzen(n); }
    });
    setzen(Number(regler.value) || 50);
  }

  function init(wurzel) {
    var f = (wurzel || document).querySelectorAll('[data-rs-bv]');
    for (var i = 0; i < f.length; i++) einrichten(f[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
